<template>
  <e-chart class="routes-chart" :option="option" autoresize />
</template>

<script>
export default {
  props: {
    routes: {
      type: Array,
      required: true,
    },
    dateRange: {
      type: Object,
      required: true,
    },
  },
  computed: {
    routesByProject() {
      return Object.groupBy(this.routes, route => route.project_name)
    },
    series() {
      return Object.entries(this.routesByProject).map(([projectName, routes]) => {
        return {
          name: projectName,
          type: 'line',
          data: routes
            .filter(route => route.average_fill_level > 0)
            .map(route => [route.date, Math.round(route.average_fill_level * 100)]),
        }
      })
    },
    option() {
      return {
        grid: {
          top: '80',
          left: '60',
          right: '40',
          bottom: '60',
          containLabel: false,
        },
        legend: {},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              formatter: ({ value }) => new Date(value).toLocaleDateString(),
            },
          },
        },
        xAxis: {
          type: 'time',
          axisLabel: {
            formatter: value => new Date(value).toLocaleDateString(),
            padding: [8, 0, 0, 0],
            hideOverlap: true,
          },
          min: this.dateRange.startDate,
          max: this.dateRange.endDate,
        },
        yAxis: {
          type: 'value',
          name: this.$t('reporting.routeChart.yAxisName'),
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 14,
            align: 'center',
          },
        },
        series: this.series,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.routes-chart {
  height: 540px;
}
</style>
